let envFile;
switch (process.env.REACT_APP_ENV) {
  case 'qa':
    envFile = require('../environments/environment.qa');
    break;
  case 'prod':
    envFile = require('../environments/environment.prod');
    break;
  default:
    envFile = require('../environments/environment.dev');
}
export const environment = envFile.environment;
